<!-- @format -->

<template>
  <div class="entry-div">
    <div class="title-bar">
      <div class="title-text">Group ({{ moptn }})</div>
      <div class="close-btn" @click="closeIt">
        <span class="fas fa-times-circle"></span>
      </div>
    </div>
    <teleport to="#app">
      <message-box ref="msgbox"></message-box>
    </teleport>
    <card-loader :LoaderText="loaderText" v-if="loading"></card-loader>
    <div class="div-content" v-else>
      <form ref="entryform">
        <div class="err" v-if="err">{{ errMsg }}</div>
        <div>
          <label for="grpdes">Group Name : <MandatoryPage /></label>
          <input
            type="hidden"
            v-model="formData.grpid"
            :disabled="moptn == 'Edit'"
          />
          <input
            type="text"
            name="grpdes"
            class="form-control"
            v-model="formData.grpdes"
            maxlength="20"
            autocomplete="off"
            ref="grpdes"
            @blur="findUser"
            tabindex="1"
          />
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Search"
          v-model="lookfor"
          tabindex="2"
        />

        <div class="grid-area">
          <card-loader v-if="loading"></card-loader>
          <table border="1" v-else>
            <thead>
              <tr>
                <th class="srnocol">#</th>
                <th>Select</th>
                <th>Student Name</th>
                <th>Father Name</th>
                <th>Class</th>
                <th>Student Code</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in studentList" :key="row.glc">
                <td>{{ index + 1 }}</td>
                <td>
                  <input
                    type="checkbox"
                    v-model="row.selflg"
                    @click="selectStudent(row)"
                  />
                </td>
                <td>{{ row.gln }}</td>
                <td>{{ row.fname }}</td>
                <td>{{ row.cldes }} &nbsp;{{ row.sec }}</td>
                <td>{{ row.glc }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="10"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </form>
      <div class="btn-div">
        <button type="button" class="btn btn-success" @click="saveRec">
          Save
        </button>
        <button type="button" class="btn btn-danger" @click="closeIt">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MessageBox from "../../components/MessageBox.vue";
export default {
  components: { MessageBox },
  emits: ["close-btn"],
  props: ["moptn"],
  data() {
    return {
      formData: {
        grpid: "",
        grpdes: "",
        gldet: [],
      },
      userId: this.$store.state.userId,
      userName: this.$store.state.userName,
      lookfor: "",
      gllist: [],
      err: false,
      loading: false,
      loaderText: "Saving",
      showclass: false,
    };
  },
  methods: {
    closeIt() {
      this.$emit("close-btn");
    },
    activateForm() {
      setTimeout(() => {
        this.$refs.grpdes.focus();
        this.getRec();
      }, 100);
    },
    async getRec() {
      this.loaderText = "Loading";
      this.formData.gldet = [];

      this.loading = true;
      await axios
        .post("group.php", {
          optn: "GetStudents",
          msearch: this.search,
          userid: this.userId,
          username: this.userName,
          grpid: this.formData.grpid,
        })
        .then((response) => {
          var resp = response.data;
          if (resp.Errorsts == false) {
            this.gllist = resp.List;
            this.gllist.map((rw) => {
              if (rw.selflg == 0) {
                rw.selflg = false;
              } else {
                rw.selflg = true;
                this.formData.gldet.push(rw.glc);
              }
            });
          } else {
            console.log("Error:" + this.ErroMsg);
          }
        });
      console.log("FormData ");
      console.log(this.formData.grpid);
      console.log(this.formData.gldet);
      this.loading = false;
    },
    isEmpty() {
      var empty = false;
      if (this.formData.grpdes == "" || this.formData.gldet.length == 0) {
        empty = true;
      }
      return empty;
    },
    async saveRec() {
      this.loading = true;
      this.loaderText = "Saving";
      var msg = "";
      if (await this.isEmpty()) {
        msg = "Please Enter Mandatory Fields  & Select Student!";
        this.$refs.msgbox.show({
          title: "Alert",
          message: msg,
          okButton: "Ok",
          msgboxType: "danger",
        });
      } else {
        // Save & Update
        await axios
          .post("group.php", {
            optn: this.moptn,
            formdata: this.formData,
            userid: this.userId,
            username: this.userName,
          })
          .then((response) => {
            console.log(response);
            var resp = response.data;
            this.errMsg = "Saved";
            if (resp.Errorsts == true) {
              this.err = true;
              this.errMsg = "Somthing went Wrong " + resp.ErrorMsg;
            } else {
              console.log("Alert");
            } // endif
          });

        this.formBlank();
        if (this.moptn == "Edit") {
          this.closeIt();
        } // endif
      }
      this.loading = false;
    },
    selectStudent(xrw) {
      if (xrw.selflg == false) {
        this.formData.gldet.push(xrw.glc);
      } else {
        this.formData.gldet.map((r, index) => {
          if (r == xrw.glc) {
            this.formData.gldet.splice(index, 1);
          }
        });
      }
    },
    async formBlank() {
      var self = this;
      Object.keys(this.formData).forEach(function (key) {
        self.formData[key] = "";
      });
      this.formData.gldet = [];
      await this.genID();
      await this.activateForm();
    },
    async fillRec(xrecid) {
      this.loaderText = "Loading";
      this.loading = true;
      var mstData = "";
      await axios
        .post("group.php", {
          optn: "Getrec",
          grpid: xrecid,
          userid: this.userId,
          username: this.userName,
        })
        .then((response) => {
          var resp = response.data;
          mstData = resp.List;
        });

      var self = this;
      Object.keys(this.formData).forEach(function (key) {
        self.formData[key] = mstData[0][key];
      });
      this.formData.gldet = [];
      this.activateForm();
      this.loading = false;
      this.lookfor = "";
    },

    async genID() {
      var muid = "";
      await axios
        .post("group.php", {
          optn: "Genid",
          uid: this.userId,
          uname: this.userName,
        })
        .then((response) => {
          var resp = response.data;
          muid = resp.uid;
        });
      this.formData.uid = muid;
    },
  },
  mounted() {
    this.loading = true;
    this.formBlank();
    this.loading = false;
  },
  computed: {
    studentList() {
      return this.gllist.filter((rw) => {
        var mystr = rw.gln.trim() + rw.glc.trim() + rw.class.trim() + rw.sec;
        return mystr.toLowerCase().includes(this.lookfor.toLowerCase());
      });
    },
  },
};
</script>

<style>
@import "./css/master.css";
</style>
<style scoped>
.class-list {
  /* position: absolute;
  top: 10px;
  border-radius: 12px;
  left: 0;
  right: 0;
  box-shadow: 0px 1px 2px 1px lightgray;
  height: 260px;
  overflow-y: auto;
  width: 450px;
  background-color: white;
  z-index: 9999; */
  position: absolute;
  top: 10px;
  border-radius: 12px;
  left: 0;
  right: 0;
  box-shadow: 0px 1px 2px 1px lightgrey;
  height: 660px;
  overflow-y: auto;
  width: 450px;
  background-color: white;
  z-index: 9999;
}
.title-bar {
  position: sticky;
  top: 0px;
  display: block;
  padding: 4px;
}

.title-bar .sbtn {
  position: absolute;
  right: 6px;
}
.class-list ul {
  margin: 0px;
  /* padding: 15px; */
  text-align: left;
}
.class-list ul li {
  list-style-type: none;
  cursor: pointer;
  margin: 0px;
  padding: 0px;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 5px;
}
.class-list ul li label {
  display: inline-block;
  margin-left: 6px;
  cursor: pointer;
}

.bgdark {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  clear: both;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.class-list label {
  width: calc(100% - 50px);
}

.grid-area {
  padding: 2px;
  width: 100%;
  background-color: white;
  max-height: calc(100vh - (450px));
  overflow: auto;
}
</style>
